module.exports = __webpack_public_path__ + "img/security.ded0567.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/security.jpg
// module id = ./assets/img/security.jpg
// module chunks = 9